import { useEffect, useState } from 'react';

// material-ui
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { gridSpacing } from 'store/constant';
import { Typography } from '@mui/material';
import { Paper } from '@mui/material';
import { getApi } from 'views/services/api';
import TotalRoomsCard from './TotalRooms';
import { Avatar, Box } from '@mui/material';
import TotalCustomersCard from './TotalCustomers';
import FoodItems from './TotalFoodItems';
import TotalReservationCard from './TotalReseravtions';
import SingleBedIcon from '@mui/icons-material/SingleBed';
import KingBedIcon from '@mui/icons-material/KingBed';
import ReserveRoom from 'views/Room/ReserveRoom';
import { useNavigate } from 'react-router';

const RoomTypeIcons = {
  single: <SingleBedIcon sx={{ fontSize: '2.5rem' }} />,
  double: <KingBedIcon sx={{ fontSize: '2.5rem' }} />,
  triple: <KingBedIcon sx={{ fontSize: '2.5rem' }} />,
  family: <KingBedIcon sx={{ fontSize: '2.5rem' }} />
};

const MainDashboard = () => {
  const theme = useTheme();
  const [isLoading, setLoading] = useState(true);
  const [openReserveRoom, setOpenReserveRoom] = useState(false);
  const [roomPropsData, setRoomPropsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const [roomData, setroomData] = useState([]);
  const [reservationData, setreservationData] = useState([]);
  const [customerData, setcustomerData] = useState([]);
  const [foodItemData, setitemsData] = useState([]);

  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  // function for fetching all the rooms data from the db

  const fetchroomData = async () => {
    try {
      // const response = await getApi(`api/room/viewallrooms/${hotel._id}`);
      const response = await getApi(`api/room/viewallrooms/${hotel?.hotelId}`);
      setroomData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReservationData = async () => {
    try {
      // const response = await getApi(`api/reservation/viewallactivereservations/${hotel._id}`);
      const response = await getApi(`api/reservation/viewallactivereservations/${hotel?.hotelId}`);
      setreservationData(response?.data?.reservationData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchcustomerData = async () => {
    try {
      // const response = await getApi(`api/customer/viewallcustomer/${hotel._id}`);
      const response = await getApi(`api/customer/viewallcustomer/${hotel?.hotelId}`);
      setcustomerData(response?.data?.customerData);
    } catch (error) {
      console.log(error);
    }
  };

  // // function for fetching all the restaurant items data from the db
  const fetchitemsData = async () => {
    try {
      // const response = await getApi(`api/restaurant/viewallitems/${hotel._id}`);
      const response = await getApi(`api/restaurant/viewallitems/${hotel?.hotelId}`);
      setitemsData(response?.data?.restaurantData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchroomData(), fetchReservationData(), fetchcustomerData(), fetchitemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openReserveRoom]);

  //function for opening dialogs

  const handleCloseReservationDialog = () => {
    setOpenReserveRoom(false);
  };

  const fetchReservationIdForActiveRooms = async (roomNo) => {
    try {
      const response = await getApi(`api/room/activroomreservationid/${roomNo}`);
      navigate(`/dashboard/reservation/view/${response?.data[0]?.reservationId}`);
    } catch (error) {
      console.log(error);
    }
  };
  const handleRoomClick = (roominfo) => {
    console.log("on room click ==>",roominfo);
    
    setTimeout(() => {
      if (roominfo.bookingStatus === 'active') {
        fetchReservationIdForActiveRooms(roominfo.roomNo);
      } else {
        setOpenReserveRoom(true);
      }
      setRoomPropsData(roominfo);
    }, 300);
  };

  return (
    <>
      <ReserveRoom open={openReserveRoom} handleClose={handleCloseReservationDialog} roomDataByProps={roomPropsData} />
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid
              item
              lg={3}
              md={6}
              sm={6}
              xs={12}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/dashboard/roommanagement');
              }}
            >
              <TotalRoomsCard isLoading={isLoading} roomData={roomData} />
            </Grid>
            <Grid
              item
              lg={3}
              md={6}
              sm={6}
              xs={12}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/dashboard/customers');
              }}
            >
              <TotalCustomersCard isLoading={isLoading} customerData={customerData} />
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              md={6}
              lg={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/dashboard/restaurant');
              }}
            >
              <FoodItems isLoading={isLoading} foodItemData={foodItemData} />
            </Grid>

            <Grid
              item
              sm={6}
              xs={12}
              md={6}
              lg={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/dashboard/reservation');
              }}
            >
              <TotalReservationCard isLoading={isLoading} reservationData={reservationData} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12} md={12}>
              <Typography variant="h5" sx={{ marginBottom: '10px' }}>
                Rooms ( {roomData?.length || 0} )
              </Typography>
              <hr />

              {roomData?.length > 0 ? (
                <Grid container spacing={gridSpacing} sx={{ marginTop: '10px' }}>
                  {roomData?.map((room) => (
                    <Grid
                      item
                      key={room.id}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      sx={{
                        cursor: 'pointer'
                      }}
                      onClick={() => handleRoomClick(room)}
                    >
                      <Box sx={{ p: 2.25 }}>
                        <Paper
                          elevation={3}
                          sx={{
                            borderRadius: '12px',
                            backgroundColor: room.bookingStatus === 'active' ? '#ffcccc' : '#fff',
                            transition: 'background-color 0.3s'
                          }}
                        >
                          <Box sx={{ p: 2 }}>
                            <Grid container direction="column">
                              <Grid item>
                                <Grid container alignItems="center" justifyContent="center">
                                  <Grid item>
                                    <Avatar
                                      sx={{
                                        cursor: 'pointer',
                                        ...theme.typography.smallAvatar,
                                        backgroundColor: room.bookingStatus === 'active' ? 'white' : theme.palette.primary[200],
                                        color: room.bookingStatus === 'active' ? 'black' : theme.palette.primary.dark,
                                        width: '53px',
                                        height: '53px'
                                      }}
                                    >
                                      {RoomTypeIcons[room.roomType.toLowerCase()]}
                                    </Avatar>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item sx={{ mb: 1.25, marginTop: '10px' }}>
                                <Typography
                                  sx={{
                                    fontSize: '1rem',
                                    fontWeight: 500,
                                    color: room.bookingStatus === 'active' ? 'black' : theme.palette.primary[200],
                                    textAlign: 'center'
                                  }}
                                >
                                  {room.roomType}
                                </Typography>
                              </Grid>
                              <Grid item sx={{ mb: 1.25, marginTop: '10px' }}>
                                <Typography
                                  sx={{
                                    fontSize: '1rem',
                                    fontWeight: 500,
                                    color: room.bookingStatus === 'active' ? 'white' : 'black',
                                    textAlign: 'center',
                                    backgroundColor: room.bookingStatus === 'active' ? 'red' : 'transparent',
                                    padding: '0.25rem 0.5rem',
                                    borderRadius: '8px',
                                    display: 'inline-block'
                                  }}
                                >
                                  {room.roomNo}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </Paper>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography variant="h5" sx={{ textAlign: 'center', color: 'grey', marginTop: '5rem' }}>
                  No Rooms Exist
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MainDashboard;
